"use strict";

document.addEventListener("DOMContentLoaded", function () {});
window.addEventListener("load", function () {});
